import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'black',
      overflow: 'hidden' // Ensures footer doesn't cause scroll if page is too short
    }}>
      <div style={{
        fontFamily: '"Nunito", sans-serif',
        fontSize: '48px',
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
        padding: '16px'
      }}>
        Uh Oh, Page Not Found.
      </div>
      <div
        onClick={() => navigate('/')}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          cursor: 'pointer',
          color: 'white',
          fontFamily: "'Fredoka One', cursive",
          fontWeight: 'normal',
          fontSize: '36px',
          textAlign: 'center',
          display: 'block',
          width: '100%',
          textShadow: isHovered ? '0 2px 4px rgba(0,0,0,0.2)' : 'none',
          transition: 'all 0.2s ease-in-out',
          position: 'absolute',
          bottom: '40px',
          left: '0',
          right: '0'
        }}
      >
        reilly.fun
      </div>
    </div>
  );
}

export default NotFoundPage;
